export default __webpack_public_path__ + "static/media/mobile_02.1ae53433.png";